module.exports = __webpack_public_path__ + "static/content-blocks-default-4d963d913075192ed4c99b53c166e78d.jpg";